import './bootstrap';

import { flare } from "@flareapp/js";
// Only enable Flare in production, we don't want to waste your quota while you're developing:
if (process.env.NODE_ENV === 'production') {
    flare.light();
}

// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// Import our custom CSS
// import '../sass/bs.scss';

import Vue from 'vue';
window.Vue = Vue;

window.VueEvent = new Vue();

import AutocompleteSearch from './components/AutoCompleteSearch.vue';
import CollectionControls from './components/CollectionControls.vue';
import CollectionControlsGuest from './components/CollectionControlsGuest.vue';
import CollectionLedger from './components/CollectionLedger.vue';
import EditPinImages from './components/EditPinImages.vue';
import FilterControls from './components/FilterControls.vue';
import GoToPage from './components/GoToPage.vue';
import PinBookControls from './components/PinBookControls.vue';
import PinBooks from './components/PinBooks.vue';
import PinCollectionControls from './components/PinCollectionControls.vue';
import ReportPin from './components/ReportPin.vue';
import Pins from './components/Pins.vue';
import PinsAd from './components/PinsAd.vue';
import PinSearch from './components/PinSearch.vue';
import SeriesSearch from './components/SeriesSearch.vue';
import TagSelector from './components/TagSelector.vue';
import TradeOffers from './components/TradeOffers.vue';
import TradeProcess from './components/TradeProcess.vue';
import TradeProtection from './components/TradeProtection.vue';
import TradeCheck from './components/TradeCheck.vue';

import BaseModal from './components/trade/BaseModal.vue';
import MyListings from './components/trade/MyListings.vue';
import PinBoard from './components/trade/PinBoard.vue';
import PinBoardItem from './components/trade/PinBoardItem.vue';
import PinDetails from './components/trade/PinDetails.vue';
import TradeLink from './components/trade/TradeLink.vue';
import TradersBoard from './components/trade/TradersBoard.vue';
import TradersBoardItem from './components/trade/TradersBoardItem.vue';
import TradersOfferConfirm from './components/trade/TradersOfferConfirm.vue';
import TradeQuest from './components/trade/TradeQuest.vue';

import AdminMembers from './components/admin/AdminMembers.vue';
import AdminMerge from './components/admin/AdminMerge.vue';
import TradeArcadeBoards from './components/admin/TradeArcadeBoards.vue';

Vue.component('autocomplete-search', AutocompleteSearch);
Vue.component('collection-controls', CollectionControls);
Vue.component('collection-controls-guest', CollectionControlsGuest);
Vue.component('collection-ledger', CollectionLedger);
Vue.component('edit-pin-images', EditPinImages);
Vue.component('filter-controls', FilterControls);
Vue.component('go-to-page', GoToPage);
Vue.component('pin-book-controls', PinBookControls);
Vue.component('pin-books', PinBooks);
Vue.component('pin-collection-controls', PinCollectionControls);
Vue.component('report-pin', ReportPin);
Vue.component('pins', Pins);
Vue.component('pins-ad', PinsAd);
Vue.component('pin-search', PinSearch);
Vue.component('series-search', SeriesSearch);
Vue.component('tag-selector', TagSelector);
Vue.component('trade-offers', TradeOffers);
Vue.component('trade-process', TradeProcess);
Vue.component('trade-protection', TradeProtection);
Vue.component('trade-check', TradeCheck);

Vue.component('base-modal', BaseModal);
Vue.component('my-listings', MyListings);
Vue.component('pin-board', PinBoard);
Vue.component('pin-board-item', PinBoardItem);
Vue.component('pin-details', PinDetails);
Vue.component('trade-link', TradeLink);
Vue.component('traders-board', TradersBoard);
Vue.component('traders-board-item', TradersBoardItem);
Vue.component('traders-offer-confirm', TradersOfferConfirm);
Vue.component('trade-quest', TradeQuest);

Vue.component('admin-members', AdminMembers);
Vue.component('admin-merge', AdminMerge);
Vue.component('trade-arcade-boards', TradeArcadeBoards);

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

new Vue().$mount('#app');